import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useDraggable } from "@dnd-kit/core";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
// Components
import { CommitmentQuestion, CheckDiv, CheckImg, QuestionText } from "./styles";
// Assets
import CheckIco from "../../../../../assets/images/ico_check.png";

const CommitmentQuestions = ({ commitmentQuestion, checkBackgroundColor, isDisabledInputs, isPatientCommitmentQuestion }) => {
  const [isMouseDown, setIsMouseDown] = useState(false);
  const [t] = useTranslation("global");

  const { transform, transition } = useDraggable({ id: commitmentQuestion.COMMITMENT_QUESTION_ID });
  const { attributes, listeners, setNodeRef } = useSortable({ id: commitmentQuestion.COMMITMENT_QUESTION_ID });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  const questionText = t(`questionnaires_commitmentQuestions_${commitmentQuestion.COMMITMENT_QUESTION_KEY}`);

  return (
    <>
      {questionText && (
        <CommitmentQuestion
          style={style}
          ref={setNodeRef}
          {...attributes}
          {...listeners}
          onMouseDown={() => setIsMouseDown(true)}
          onMouseUp={() => setIsMouseDown(false)}
          onMouseLeave={() => setIsMouseDown(false)}
          cursor={isMouseDown ? "grabbing" : "grab"}
          isDisabledInputs={isDisabledInputs}
        >
          <CheckDiv background={checkBackgroundColor}>
            {isPatientCommitmentQuestion && <CheckImg src={CheckIco} alt="ico-check" />}
          </CheckDiv>
          <QuestionText>{questionText}</QuestionText>
        </CommitmentQuestion>
      )}
    </>
  );
};

export default CommitmentQuestions;
